module.exports = __webpack_public_path__ + "img/DRmed-01.ed999e15.png";